import { axios } from "../Axios";
import { handleResponse, handleError } from "../Response";

// Define your api url from any source.
// Pulling from your .env file when on the server or from localhost when locally
const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

/** @param {string} resource */
const getAll = (resource: string) => {
  return axios.get(`${BASE_URL}/${resource}`).then(handleResponse);
  // .catch(handleError);
};

/** @param {string} resource */
/** @param {string} id */

const getSingle = (resource: string, id: string, queryParams = "") => {
  return axios
    .get(`${BASE_URL}/${resource}/${id}?${queryParams}`)
    .then(handleResponse);
  // .catch(handleError);
};
/** @param {string} resource */
/** @param {string} slug */
const getSingleBySlug = (resource: string, slug: string, queryParams = "") => {
  return axios
    .get(`${BASE_URL}/${resource}/slug/${slug}?${queryParams}`)
    .then(handleResponse);
  // .catch(handleError);
};

/** @param {string} resource */
/** @param {object} model */
const post = (resource: string, model: object, queryParam = "") => {
  return axios
    .post(`${BASE_URL}/${resource}${queryParam}`, model)
    .then(handleResponse);
  // .catch(handleError);
};

/** @param {string} resource */
/** @param {object} model */
const put = (resource: string, id: string, model: object) => {
  return axios.put(`${BASE_URL}/${resource}/${id}`, model).then(handleResponse);
  // .catch(handleError);
};

/** @param {string} resource */
/** @param {object} model */
const patch = (resource: string, id: string, model: object) => {
  return axios
    .patch(`${BASE_URL}/${resource}/${id}`, model)
    .then(handleResponse);
  // .catch(handleError);
};

/** @param {string} resource */
/** @param {string} id */
const remove = (resource: string, id: string) => {
  return axios.delete(`${BASE_URL}/${resource}/${id}`).then(handleResponse);
  // .catch(handleError);
};
const removeWithoutId = (resource: string) => {
  return axios.delete(`${BASE_URL}/${resource}`).then(handleResponse);
  // .catch(handleError);
};

export const apiProvider = {
  getAll,
  getSingle,
  getSingleBySlug,
  post,
  put,
  patch,
  remove,
  removeWithoutId,
};
